<template>
  <div>
    <v-overlay class="d-flex justify-center align-center" v-model="showSchemataOverlay" persistent>
      <SchemataOverlay :schemata="selectedSchemataValue" @schemata-back="() => {showSchemataOverlay = false}"></SchemataOverlay>
    </v-overlay>

    <v-overlay class="d-flex justify-center align-center" v-model="showShiftOverlay" persistent>
      <ShiftOverlay :shift="selectedShiftValue" @shift-back="() => {showShiftOverlay = false}"></ShiftOverlay>
    </v-overlay>

    <v-overlay class="d-flex justify-center align-center" v-model="showFreeDaysOverlay" persistent>
      <FreeDaysOverlay :free-day="selectedFreeDayValue" @freedays-back="() => {showFreeDaysOverlay = false}"></FreeDaysOverlay>
    </v-overlay>

    <v-overlay class="d-flex justify-center align-center" v-model="showReliefDaysOverlay" persistent>
      <FreeDaysOverlay :free-day="selectedReliefDayValue" @freedays-back="() => {showReliefDaysOverlay = false}"></FreeDaysOverlay>
    </v-overlay>

    <v-overlay class="d-flex justify-center align-center" v-model="showMiscOverlay" persistent>
      <FreeDaysOverlay :free-day="selectedMiscValue" @freedays-back="() => {showMiscOverlay = false}"></FreeDaysOverlay>
    </v-overlay>

    <div class="d-flex justify-center mt-4">
      <v-btn-toggle v-model="selectedMode" class="mb-4" rounded tile mandatory>
        <v-btn variant="outlined" color="primary" value="group" @click="ChangeOption">Gruppe</v-btn>
        <v-btn variant="outlined" color="primary" value="user" @click="ChangeOption">Benutzer</v-btn>
        <v-btn variant="outlined" color="primary" value="newgroup" @click="ChangeOption">neue Schicht</v-btn>
      </v-btn-toggle>
    </div>
    
    
    <div class="d-flex flex-column align-center mt-4 text-center">
      <h2>WDP Einstellungen</h2>
    </div>
    <div class="v-container mt-4 w-100">
      <v-row>
        <v-col>
          <v-autocomplete
              v-if="selectedMode === 'group'"
              label="Arbeitzeitmodel"
              :item-title="(item) => `${item.shiftNr} ${item.displayName}`"
              :items="shiftSettings"
              v-model="selectedShift"
              clearable
              no-data-text="Keine Arbeitszeitmodel gefunden"
              return-object
          ></v-autocomplete>
          <v-autocomplete
              v-if="selectedMode === 'user'"
              label="Benutzer auswählen"
              :items="userList"
              :item-title="GetFullName"
              clearable
              v-model="selectedUser"
              no-data-text="Keine Benutzer gefunden"
              return-object
          ></v-autocomplete>
          <div v-if="selectedMode == 'newgroup'">
            <v-autocomplete
              label="Schicht auswählen"
              :items="employCycles"
              :item-title="(item) => `${item.cycleid} ${item.machineid} (${item.jobids.join(', ')})`"
              item-value="cycleid"
              clearable
              v-model="selectedSchicht"
              no-data-text="Keine Schicht gefunden"
              return-object
            ></v-autocomplete>
          </div>
        </v-col>
        <v-col class="d-flex justify-center align-center" cols="2" v-if="edited">
          <v-btn @click="Save" class="mb-2" icon height="32" width="32">
            <v-icon color="primary">mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <div v-if="userShift">
        <h3 class="mb-8">Die Schicht ist Benutzerbezogen angelegt</h3>
        <v-row>
          <v-col class="d-flex justify-center align-center" cols="2" v-if="userShift">
            <v-tooltip text="Es werden die Benutzerbezogenen Schichtdaten gelösch. Dem Benutzer wird die Standard Schicht zugewiesen" bottom>
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  @click="DeleteUserShift"
                  class="mb-2"
                  icon
                  height="32"
                  width="32"
                >
                  <v-icon color="primary">mdi-delete</v-icon> Entfernen
                </v-btn>
              </template>
            </v-tooltip>

            <!--<v-btn @click="DeleteUserShift" class="mb-2" icon height="32" width="32">
              <v-icon color="primary">mdi-delete</v-icon> Entfernen
            </v-btn>-->
          </v-col>
        </v-row>
      </div>
      <div class="d-flex w-100 flex-column align-center" v-if="selectedShift != null">
        <div class="underline-full">
          <v-row no-gutters>
            <v-col cols="8">
              <VCheckbox class="v-checkbox--default w-100" label="Freie-Tage Schemen" v-model="selectedShift.schematasEnabled"></VCheckbox>
            </v-col>
            <v-col class="text-right">
              <v-btn @click="AddSchemata" class="mb-2" icon height="24" width="24">
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>      
        <div :class="[selectedShift.schematasEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
                v-for="item in selectedShift.schematas"
                :key="item"
                class="item-entry"
                @click="OpenSchemata(item)"
            >
              <v-row class="border">
                <v-col class="h-100">{{ JSON.stringify(item.schemata) }}</v-col>
                <v-col class="text-right">
                  <v-btn @click="RemoveSchemata(item)" icon height="24" width="24">
                    <v-icon color="primary">mdi-trash-can</v-icon>
                  </v-btn></v-col>
              </v-row>


            </v-list-item>
          </v-list>
        </div>

        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <VCheckbox class="v-checkbox--default w-100" label="Dienste" v-model="selectedShift.shiftsEnabled"/>
            </v-col>
            <v-col class="text-right">Nr</v-col>
            <v-col class="text-right">Max</v-col>
          </v-row>
        </div>
        <div :class="[selectedShift.shiftsEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
                v-for="item in selectedShift.shifts"
                :key="item"
                class="item-entry"
                @click="OpenShift(item)"
            >
              <v-row class="border">
                <v-col class="h-100">{{ item.name }}</v-col>
                <v-col class="text-right">
                  {{ item.nr }}
                </v-col>
                <v-col class="text-right">
                  {{ item.max }}
                </v-col>
              </v-row>


            </v-list-item>
          </v-list>
        </div>
        
        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <VCheckbox class="v-checkbox--default w-100" label="Freie Tage" v-model="selectedShift.freeDaysEnabled"/>
            </v-col>
            <v-col class="text-right">Max</v-col>
          </v-row>
        </div>
        <div :class="[selectedShift.freeDaysEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
              v-for="item in selectedShift.freeDays"
              :key="item"
              class="item-entry"
              @click="OpenFreeDays(item)"
            >
              <v-row no-gutters>
                <v-col class="h-100">{{ item.name }}</v-col>
                <v-col class="text-right">
                  {{item.max}}
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </div>
        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <VCheckbox class="v-checkbox--default w-100" label="Entlastungstage" v-model="selectedShift.reliefDaysEnabled"/>
            </v-col>
            <v-col class="text-right">Max</v-col>
          </v-row>
        </div>
        <div :class="[selectedShift.reliefDaysEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
              v-for="item in selectedShift.reliefDays"
              :key="item"
              class="item-entry"
              @click="OpenReliefDays(item)"
            >
              <v-row no-gutters>
                <v-col class="h-100">{{ item.name }}</v-col>
                <v-col class="text-right">
                  {{item.max}}
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </div>
        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <VCheckbox class="v-checkbox--default w-100" label="Sonstige" v-model="selectedShift.miscEnabled"/>
            </v-col>
            <v-col class="text-right">Max</v-col>
          </v-row>
        </div>
        <div :class="[selectedShift.miscEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
                v-for="item in selectedShift.misc"
                :key="item"
                class="item-entry"
                @click="OpenFreeDays(item)"
            >
              <v-row no-gutters>
                <v-col class="h-100">{{ item.name }}</v-col>
                <v-col class="text-right">
                  {{item.max}}
                </v-col>
              </v-row>


            </v-list-item>
          </v-list>
        </div>

        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <p class="v-checkbox--default w-100">Erweiterte Regeln</p> 
            </v-col>
          </v-row>
        </div>
        <div class="w-100 mb-4">
          <v-row class="mt-2 mx-0">
            <v-col class="ma-0">
              <VCheckbox class="v-checkbox--default w-100" label="Freie Tage in 2 Wochen beschränken" v-model="selectedShift.limitFreeDaysInTwoWeeks"/>
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="d-flex w-100 flex-column align-center" v-else-if="selectedSchicht != null">
        <h3 class="mb-8">Schicht Eingabe</h3>
        <v-row class="w-100">
          <v-col>
            <v-text-field disabled label="Schichtname" v-model="newShiftSettings.shiftNr"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="w-100">
          <v-col>
            <v-text-field label="Displayname" v-model="newShiftSettings.displayName"></v-text-field>
          </v-col>
        </v-row>
        <div class="underline-full">
          <v-row no-gutters>
            <v-col cols="8">
              <VCheckbox class="v-checkbox--default w-100" label="Freie-Tage Schemen" v-model="newShiftSettings.schematasEnabled"></VCheckbox>
            </v-col>
            <v-col class="text-right">
              <v-btn @click="AddSchemata" class="mb-2" icon height="24" width="24">
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>      
        <div :class="[newShiftSettings.schematasEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
                v-for="item in newShiftSettings.schematas"
                :key="item"
                class="item-entry"
                @click="OpenSchemata(item)"
            >
              <v-row class="border">
                <v-col class="h-100">{{ JSON.stringify(item.schemata) }}</v-col>
                <v-col class="text-right">
                  <v-btn @click="RemoveSchemata(item)" icon height="24" width="24">
                    <v-icon color="primary">mdi-trash-can</v-icon>
                  </v-btn></v-col>
              </v-row>


            </v-list-item>
          </v-list>
        </div>

        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <VCheckbox class="v-checkbox--default w-100" label="Dienste" v-model="newShiftSettings.shiftsEnabled"/>
            </v-col>
            <v-col class="text-right">Nr</v-col>
            <v-col class="text-right">Max</v-col>
          </v-row>
        </div>
        <div :class="[newShiftSettings.shiftsEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
                v-for="item in newShiftSettings.shifts"
                :key="item"
                class="item-entry"
                @click="OpenShift(item)"
            >
              <v-row class="border">
                <v-col class="h-100">{{ item.name }}</v-col>
                <v-col class="text-right">
                  {{ item.nr }}
                </v-col>
                <v-col class="text-right">
                  {{ item.max }}
                </v-col>
              </v-row>


            </v-list-item>
          </v-list>
        </div>
        
        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <VCheckbox class="v-checkbox--default w-100" label="Freie Tage" v-model="newShiftSettings.freeDaysEnabled"/>
            </v-col>
            <v-col class="text-right">Max</v-col>
          </v-row>
        </div>
        <div :class="[newShiftSettings.freeDaysEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
              v-for="item in newShiftSettings.freeDays"
              :key="item"
              class="item-entry"
              @click="OpenFreeDays(item)"
            >
              <v-row no-gutters>
                <v-col class="h-100">{{ item.name }}</v-col>
                <v-col class="text-right">
                  {{item.max}}
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </div>
        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <VCheckbox class="v-checkbox--default w-100" label="Entlastungstage" v-model="newShiftSettings.reliefDaysEnabled"/>
            </v-col>
            <v-col class="text-right">Max</v-col>
          </v-row>
        </div>
        <div :class="[newShiftSettings.reliefDaysEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
              v-for="item in newShiftSettings.reliefDays"
              :key="item"
              class="item-entry"
              @click="OpenReliefDays(item)"
            >
              <v-row no-gutters>
                <v-col class="h-100">{{ item.name }}</v-col>
                <v-col class="text-right">
                  {{item.max}}
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </div>
        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <VCheckbox class="v-checkbox--default w-100" label="Sonstige" v-model="newShiftSettings.miscEnabled"/>
            </v-col>
            <v-col class="text-right">Max</v-col>
          </v-row>
        </div>
        <div :class="[newShiftSettings.miscEnabled ? '' : 'item-entry-disabled',
        'w-100',
        'mb-4']">
          <v-list>
            <v-list-item
                v-for="item in newShiftSettings.misc"
                :key="item"
                class="item-entry"
                @click="OpenFreeDays(item)"
            >
              <v-row no-gutters>
                <v-col class="h-100">{{ item.name }}</v-col>
                <v-col class="text-right">
                  {{item.max}}
                </v-col>
              </v-row>


            </v-list-item>
          </v-list>
        </div>

        <div class="underline-full">
          <v-row no-gutters>
            <v-col>
              <p class="v-checkbox--default w-100">Erweiterte Regeln</p> 
            </v-col>
          </v-row>
        </div>
        <div class="w-100 mb-4">
          <v-row class="mt-2 mx-0">
            <v-col class="ma-0">
              <VCheckbox class="v-checkbox--default w-100" label="Freie Tage in 2 Wochen beschränken" v-model="newShiftSettings.limitFreeDaysInTwoWeeks"/>
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="d-flex justify-center" v-else>
        <small v-if="selectedMode == 'group'" class="text-center">Bitte ein Arbeitzeitmodel auswählen</small>
        <small v-if="selectedMode == 'user'" class="text-center">Bitte einen Benutzer auswählen</small>
        <small v-if="selectedMode == 'newgroup'" class="text-center">Bitte eine Schicht auswählen</small>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import {defineComponent, onMounted, ref, watch, computed} from "vue";
import {GetShiftSettings, SetShiftSettings, createDefaultShiftSettings} from "@/data/shiftSettings";

import SchemataOverlay from "@/components/ShiftSettingsOverlays/SchemataOverlay.vue";
import ShiftOverlay from "@/components/ShiftSettingsOverlays/ShiftOverlay.vue";
import FreeDaysOverlay from "@/components/ShiftSettingsOverlays/FreeDaysOverlay.vue";
import ReliefDaysOverlay from "@/components/ShiftSettingsOverlays/ReliefDaysOverlay.vue";
import {onBeforeRouteLeave} from "vue-router";
import {createDialog, notifyError, notifyInfo} from "vuetify3-dialog";
import {GetEmployDatas, SetEmployData} from "@/data/employData";
import { useCollection, useFirestore } from 'vuefire'
import { collection, updateDoc, doc } from 'firebase/firestore'

export default defineComponent({
  name: 'WorksettingsView',
  components: {
    SchemataOverlay,
    ShiftOverlay,
    FreeDaysOverlay,
    ReliefDaysOverlay,
  },
  setup() {
    const shiftSettings = ref<ShiftSettings[]>([]);
    const selectedShift = ref<ShiftSettings | null | undefined>(null);
    
    const userList = ref<EmployData[]>([]);
    const selectedUser = ref<EmployData | null>(null);

    const db = useFirestore()
    const employ = useCollection(collection(db, 'employ'))
    const selectedSchicht = ref(null)
    const employCycles = computed(() => {
      const cycleMap = new Map()
      employ.value.forEach(({ cycleid, machineid, jobid }) => {
        if (!cycleMap.has(cycleid)) {
          cycleMap.set(cycleid, { cycleid, machineid, jobids: new Set() })
        }
        cycleMap.get(cycleid).jobids.add(jobid) // Set verhindert doppelte jobids
      })
      // Konvertiere Sets zurück in Arrays, weil Vue keine Sets in Templates rendert
      const allCycles = Array.from(cycleMap.values()).map(entry => ({
        ...entry,
        jobids: Array.from(entry.jobids)
      }))
      // Filtere die Elemente basierend auf filterCycles
      return allCycles.filter(cycle => !shiftSettings.value.some(filter => filter.shiftNr === cycle.cycleid))
    })
    
    const showSchemataOverlay = ref(false);
    const showShiftOverlay = ref(false);
    const showFreeDaysOverlay = ref(false);
    const showReliefDaysOverlay = ref(false);
    const showMiscOverlay = ref(false);
    const showNewShiftOverlay = ref(false);
    
    const selectedSchemataValue = ref<Schemata | null>(null);
    const selectedShiftValue = ref<Shift | null>(null);
    const selectedFreeDayValue = ref<Shift | null>(null);
    const selectedReliefDayValue = ref<Shift | null>(null);
    const selectedMiscValue = ref<Shift | null>(null);
    
    const edited = ref(false);
    const firstRender = ref(true);
    const userShift = ref(false)
    
    const selectedMode = ref('group');
    const AddSchemata = () => {
      let newEntry = {schemata: []}
      
      selectedShift.value.schematas.push(newEntry);
      selectedSchemataValue.value = newEntry;
      
      showSchemataOverlay.value = true;
    }

    const newShiftSettings = ref<ShiftSettings>(createDefaultShiftSettings());
    const AddShift = () => {
      newShiftSettings.value.shiftNr = selectedSchicht.value.cycleid
      showNewShiftOverlay.value = true
    }
    
    const OpenSchemata = (schemata:Schemata) => {
      showSchemataOverlay.value = true;
      selectedSchemataValue.value = schemata;
    }
    
    const RemoveSchemata = (schemata:Schemata) => {
      selectedShift.value.schematas = selectedShift.value.schematas.filter(entry => entry !== schemata);
      edited.value = true;
    }
    
    const OpenShift = (shift:Shift) => {
      selectedShiftValue.value = shift;
      showShiftOverlay.value = true;
    }
    
    const OpenFreeDays = (shift:Shift) => {
      showFreeDaysOverlay.value = true;
      selectedFreeDayValue.value = shift;
    }
    
    const OpenReliefDays = (shift:Shift) => {
      showReliefDaysOverlay.value = true;
      selectedReliefDayValue.value = shift;
    }
    const OpenMisc = (shift:Shift) => {
      showMiscOverlay.value = true;
      selectedMiscValue.value = shift;
    }

    const ChangeOption = () => {
      selectedShift.value = null
      selectedUser.value = null
      edited.value = false
      newShiftSettings.value = createDefaultShiftSettings()
      selectedSchicht.value = null
      firstRender.value = true
    }
    
    const GetFullName = (item:EmployData) => {
      return `${item.firstname} ${item.surname} (${item.cycleid}) (${item.mean_std_worktime_week} h)`;
    }
    
    const Save = () => {
      if(edited.value)
      {
        createDialog({ title: "Änderungen speichern?",
          text: `Möchtest du deine Änderungen wirklich speichern?`,
          buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
            .then((answer) => {
              if(answer) {
                if(selectedMode.value === 'group') {
                  SetShiftSettings(selectedShift.value);
                }
                else if(selectedMode.value === 'user') {
                  selectedUser.value.shiftSettings = selectedShift.value;
                  SetEmployData(selectedUser.value);
                  selectedUser.value = null;
                }
                else if(selectedMode.value === 'newgroup') {
                  SetShiftSettings(newShiftSettings.value);
                  (async () => {
                    shiftSettings.value = await GetShiftSettings()
                    selectedSchicht.value = null
                    newShiftSettings.value = createDefaultShiftSettings()
                  })();
                }

                edited.value = false;
              }
            })
      }
    }

    const DeleteUserShift = () => {
      createDialog({ title: "Benutzerbezogenen Schichtdaten löschen?",
        text: `Möchtest du die Benutzerbezogenen Schichtdaten wirklich löschen?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then((answer) => {
            if(answer) {
              selectedUser.value.shiftSettings = null
              SetEmployData(selectedUser.value)
              selectedShift.value = null
              selectedUser.value = null
              edited.value = false
              userShift.value = false
            }
          })
    }

    onBeforeRouteLeave((to, from, next) => {
      if(edited.value)
      {
        createDialog({ title: "Änderungen verwerfen?",
          text: `Möchtest du deine Änderungen wirklich verwerfen?`,
          buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
            .then((answer) => {
              if(answer) {
                next();
              }
            })
      }
      else{
        next();
      }
    });

    watch(selectedShift, (newVal) => {
      if(firstRender.value)
      {
        firstRender.value = false;
        return;
      }
      edited.value = true;
    }, { deep: true });

    watch(selectedShift,  async (newVal) => {
      if(edited.value)
      {
        edited.value = false;
      }
    });

    watch(newShiftSettings, (newVal) => {
      if(firstRender.value)
      {
        firstRender.value = false;
        return;
      }
      edited.value = true;
    }, { deep: true });

    watch(selectedSchicht,  async (newVal) => {
      if(edited.value)
      {
        edited.value = false;
      }
      if (newVal) {
        newShiftSettings.value = createDefaultShiftSettings()
        newShiftSettings.value.shiftNr = newVal.cycleid
      }
    });

    watch(selectedUser, (newVal) => {
      if(firstRender.value)
      {
        firstRender.value = false;
        return;
      }
      edited.value = true;
    }, { deep: true });

    watch(selectedUser,  async (newVal) => {
      if(!selectedUser.value)
      {
        selectedShift.value = null;
        return;
      }
      
      if(selectedUser.value.shiftSettings == null)
      {
        const defaultShift = shiftSettings.value.filter(shift => shift.shiftNr === selectedUser.value.cycleid)[0];
        userShift.value = false
        if(defaultShift)
        {
          selectedUser.value.shiftSettings = {...defaultShift};
          selectedShift.value = selectedUser.value.shiftSettings;
        }
        else{
          await notifyError('Keine Standardschicht für diesen User gefunden');
          selectedShift.value = null;
        }
      }
      else
      {
        notifyInfo('Es wurde eine User bezogene Standardschicht gefunden');
        selectedShift.value = selectedUser.value.shiftSettings;
        userShift.value = true
      }
     
      if(edited.value)
      {
        edited.value = false;
      }
    });
    
    watch(selectedMode, (newVal) => {
      selectedShift.value = null;
      edited.value = false;
    });
    
    onMounted(async () => {
      shiftSettings.value = await GetShiftSettings();
      userList.value = await GetEmployDatas();
      
      edited.value = false;
    })
    
    return {shiftSettings, selectedShift, userList, selectedUser, showSchemataOverlay, GetFullName, 
      showShiftOverlay, showFreeDaysOverlay, showMiscOverlay, selectedMode, Save,RemoveSchemata, 
      edited, selectedSchemataValue, selectedShiftValue, selectedFreeDayValue, selectedMiscValue,  
      AddSchemata, OpenSchemata, OpenShift, OpenFreeDays, OpenMisc, AddShift, selectedSchicht, 
      employCycles, showNewShiftOverlay, newShiftSettings, OpenReliefDays, showReliefDaysOverlay,
      selectedReliefDayValue, ChangeOption, userShift, DeleteUserShift}
  }
})

</script>

<style scoped>
.underline-full{
  border-bottom: 1px solid black;
  width: 100%;
  display: block;
}

.item-entry{
  border-bottom: 1px solid black;
  border-color: lightgray;
  margin-top: 2px;
  margin-bottom: 2px;
}

.item-entry:hover{
  background-color: #f0f0f0;
}

.item-entry-disabled{
  opacity: 0.5;
}
</style>